<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Priority / MX Merchant Connection</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="alert alert-info">
      In order to set up Priority / MX Merchant for use with Capitan, you must create an API key.
      <br>
      This can be done in the <a href="https://app.mxmerchant.com">MX Merchant web app</a>. Navigate to "Settings", followed by "Applications / API", and select "Add Application", then enter the resulting Consumer API Key and Secret below.
      <br>
      If you do not know your Merchant ID, it can be found in the "Applications / API" table after the key is created.
    </div>

    <div class="form-group">
      <label for="connectionName">Connection Name</label>
      <input id="connectionName" name="connectionName"
             type="text" required
             class="form-control"
             [(ngModel)]="connectionName">
      <small class="form-text text-muted">
        This name is for internal organization only, and does not impact the connection.
      </small>
    </div>

    <div class="form-group">
      <label for="consumerApiKey">Consumer API Key</label>
      <input id="consumerApiKey" name="consumerApiKey"
             type="text" required
             class="form-control"
             [(ngModel)]="consumerApiKey">
    </div>

    <div class="form-group">
      <label for="consumerApiSecret">Consumer API Secret</label>
      <input id="consumerApiSecret" name="consumerApiSecret"
             type="text" required
             class="form-control"
             [(ngModel)]="consumerApiSecret">
    </div>

    <div class="form-group">
      <label for="merchantId">Merchant ID</label>
      <input id="merchantId" name="merchantId"
             type="text" required
             class="form-control"
             [(ngModel)]="merchantId">
    </div>

    <div class="alert alert-danger" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            (click)="handleSubmit()"
            [disabled]="!allInputsValid()"
            [class.disabled]="!allInputsValid()"
            *ngIf="!loadingSave">
      Save
    </button>
    <button class="btn btn-primary disabled" type="button" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
